module.exports = __webpack_public_path__ + "static/media/about-us.31e0eaf0.jpg";